import { ERD, PaymentReceiptActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  PAYMENT_RECEIPT_ENDPOINTS_URLS,
  PAYMENT_RECEIPT_TAGS,
} from "./api-payment-receipt.constant";
import { SUBSCRIPTION_TAGS } from "../subscription/api-subscription.constant";

export const {
  useUploadPaymentReceiptMutation,
  useReadManyPaymentReceiptsQuery,
  useApprovePaymentReceiptMutation,
  useRejectPaymentReceiptMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadPaymentReceipt: builder.mutation<
      void,
      { payload: PaymentReceiptActions["upload"]["payload"]; file: File }
    >({
      query: ({ payload, file }) => {
        const formData = new FormData();
        formData.append("subscriptionId", payload.subscriptionId);
        formData.append("price", payload.price.toString());
        formData.append("receipt", file);
        return {
          url: PAYMENT_RECEIPT_ENDPOINTS_URLS.upload,
          method: "post",
          body: formData,
        };
      },
      invalidatesTags: [PAYMENT_RECEIPT_TAGS.paymentReceipt, SUBSCRIPTION_TAGS.subscription],
    }),
    readManyPaymentReceipts: builder.query<
      ERD<PaymentReceiptActions["readMany"]>,
      QueryArgsNew<PaymentReceiptActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: PAYMENT_RECEIPT_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [PAYMENT_RECEIPT_TAGS.paymentReceipt],
    }),
    approvePaymentReceipt: builder.mutation<
      void,
      QueryArgsNew<PaymentReceiptActions["approve"]>
    >({
      query: ({ params }) => ({
        url: PAYMENT_RECEIPT_ENDPOINTS_URLS.approve(params),
        method: "put",
      }),
      invalidatesTags: [PAYMENT_RECEIPT_TAGS.paymentReceipt, SUBSCRIPTION_TAGS.subscription],
    }),
    rejectPaymentReceipt: builder.mutation<
      void,
      QueryArgsNew<PaymentReceiptActions["reject"]>
    >({
      query: ({ params }) => ({
        url: PAYMENT_RECEIPT_ENDPOINTS_URLS.reject(params),
        method: "put",
      }),
      invalidatesTags: [PAYMENT_RECEIPT_TAGS.paymentReceipt, SUBSCRIPTION_TAGS.subscription],
    }),
  }),
});
